<template>
  <div class="icon-container">
    <img class="icon" :src="`${assetPath}${iconName}`" />
  </div>
</template>

<script>
export default {
  props: {
    icon: String,
    iconID: Number,
    color: String
  },
  computed: {
    assetPath () {
      let path
      /* eslint-disable no-undef */
      if (typeof PlinqApiUrlData !== 'undefined') {
        path = PlinqApiUrlData.VUE_APP_ASSETS_PATH
        /* eslint-enable no-undef */
      } else {
        path = process.env.VUE_APP_ASSETS_PATH
      }

      return path
    },
    iconName () {
      let returnValue
      if (this.icon !== undefined) {
        returnValue = this.icon
      } else {
        switch (this.iconID) {
          case 100:
            returnValue = 'internet'
            break
          case 200:
            returnValue = 'telefonie'
            break
          case 300:
            returnValue = 'televisie'
            break
          case 400:
            returnValue = 'plus'
            break
          case 500:
            returnValue = 'installatie'
            break
          case 600:
            returnValue = 'plus'
            break
          case 700:
            returnValue = 'plus'
            break
          case 900:
            returnValue = 'netwerkkosten'
            break
        }
        returnValue += '.svg'
      }
      return returnValue
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-container {
  height: 100%;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
}

.icon {
  color: color(6);
  height: 40%;
  width: auto;
}
</style>
